import { render } from "./WalletChange.vue?vue&type=template&id=5b195471"
import script from "./WalletChange.vue?vue&type=script&lang=js"
export * from "./WalletChange.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__